import React from "react";
import { Link } from "react-router-dom";

export const CappedLinkList = ({
  ids,
  maxItems = 10,
  morePath,
  children,
}: {
  ids?: string[];
  maxItems?: number;
  morePath: string;
  children: (id: string) => React.ReactNode;
}) => {
  ids ??= [];
  const overflow = ids.length > maxItems;
  const childNodes = ids.slice(0, maxItems - +overflow).map(children);

  return (
    <div>
      {childNodes}
      {overflow && (
        <Link className="block hover:underline" to={morePath}>
          {ids.length - childNodes.length} More &raquo;
        </Link>
      )}
    </div>
  );
};
